import React from 'react'
import { Select, Form, Input, Row, Col } from 'antd'
import MemoryStore from '../../../../utils/memory-store'
import Notes from '../../../../reusables/components/notes'

class FieldMappingDesJson extends React.Component {
  constructor (props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.state = {
      fieldMapping: this.props.fieldMapping,
      type: this.props.fieldMapping.desType
    }
  }

  onFieldChange (key, value) {
    this.entry.custom.isModifiedSubform = true
    this.props.fieldMapping[key] = value
  }

  render () {
    return (
      <Row>
        <Col span={24}>
          <Form name='field-mapping-des-json'>
            <Form.Item>
              Attribute Path (optional)
              <Input
                name='path'
                placeholder='Provide a path for your Attribute'
                disabled={MemoryStore.userProfile.teamPrivileges.datamappings === 'Reader'}
                defaultValue={this.state.fieldMapping.desPath}
                onChange={(e) => {
                  this.onFieldChange('desPath', e.target.value)
                }}
              />
            </Form.Item>
            <Form.Item>
              <span style={{ color: 'red' }}>* </span>Attribute Name
              <Input
                name='attribute_name'
                placeholder='Provide an Attribute Name'
                disabled={MemoryStore.userProfile.teamPrivileges.datamappings === 'Reader'}
                defaultValue={this.state.fieldMapping.desName}
                required
                onChange={(e) => {
                  this.onFieldChange('desName', e.target.value)
                }}
              />
            </Form.Item>
            <Form.Item>
              Attribute Type
              <Select
                className='attribute_type'
                disabled={MemoryStore.userProfile.teamPrivileges.datamappings === 'Reader'}
                placeholder='Specify an Attribute Type'
                defaultValue={this.state.fieldMapping.desType}
                onChange={(value) => {
                  this.onFieldChange('desType', value)
                }}
              >
                <Select.Option value='1'>String</Select.Option>
                <Select.Option value='2'>Integer</Select.Option>
                <Select.Option value='3'>Double</Select.Option>
                <Select.Option value='4'>Percentage</Select.Option>
              </Select>
            </Form.Item>
            <Notes
              disabled={MemoryStore.userProfile.teamPrivileges.datamappings === 'Reader'}
              notes={this.state.fieldMapping.desNotes}
              onChange={(e) => {
                this.onFieldChange('desNotes', e.target.value)
              }}
            />
          </Form>
        </Col>
      </Row>
    )
  }
}

export default FieldMappingDesJson
